/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type CreateStoreInput = {|
  billingAddress?: ?string,
  birthdayCashbackRate?: ?number,
  categoryIds?: ?$ReadOnlyArray<string>,
  clientMutationId?: ?string,
  customerServiceEmail?: ?string,
  defaultCashbackRate?: ?number,
  email?: ?string,
  fastCashEnabled?: ?boolean,
  isFeatured?: ?boolean,
  name: string,
  normalClosingHour?: ?number,
  normalOpeningHour?: ?number,
  phoneNumber: string,
  storeNumber?: ?string,
  sundayClosingHour?: ?number,
  sundayOpeningHour?: ?number,
  uniqueInState: boolean,
|};
export type createStoreMutationVariables = {|
  input: CreateStoreInput
|};
export type createStoreMutationResponse = {|
  +createStore: ?{|
    +errors: ?$ReadOnlyArray<{|
      +key: string,
      +messages: $ReadOnlyArray<string>,
    |}>,
    +storeEdge: ?{|
      +node: ?{|
        +id: string
      |}
    |},
  |}
|};
export type createStoreMutation = {|
  variables: createStoreMutationVariables,
  response: createStoreMutationResponse,
|};
*/


/*
mutation createStoreMutation(
  $input: CreateStoreInput!
) {
  createStore(input: $input) {
    errors {
      key
      messages
    }
    storeEdge {
      node {
        id
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "CreateStoreInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateStorePayload",
    "kind": "LinkedField",
    "name": "createStore",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ValidationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "key",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "messages",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "StoreEdge",
        "kind": "LinkedField",
        "name": "storeEdge",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Store",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "createStoreMutation",
    "selections": (v1/*: any*/),
    "type": "RootMutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "createStoreMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "createStoreMutation",
    "operationKind": "mutation",
    "text": "mutation createStoreMutation(\n  $input: CreateStoreInput!\n) {\n  createStore(input: $input) {\n    errors {\n      key\n      messages\n    }\n    storeEdge {\n      node {\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '208e33c24c679a048b0c00eaca42bb72';

module.exports = node;
